import { useEffect, useRef, useState } from "react";
import { List, Search, Upload } from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  chargeCreation,
  deleteCharges,
  getChargesByChhId,
  getChargesFromRatemaster,
  getJobInfo,
  getTemplates,
  searchCharge,
  updateCharges,
} from "../../api/finance/addChargesApi";
import { getInvoiceByJobId } from "../../api/finance/invoiceSearchApi";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import { statusByContext, statusIdsByContexts } from "../../api/statusApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Modal from "../../components/Modal";
import EvinvComponent from "../../components/finance/EvInv/EVINVComponent";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import {
  BulkProceedStatusStyle,
  ChargeCellStyle,
  chargeCreationStatusLabelStyle,
  DateCellRenderer,
  EVInvCellStyle,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";
import { FORMS, MODULES, STATUS_GROUPS } from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import AddCharges from "./AddCharges";
import AddMultipleCharges from "./AddMultipleCharges";

import { MdDeleteForever } from "react-icons/md";
import {
  downloadBulkTemplate,
  JobChargeDetailsById,
  searchBulkJobCharge,
  uploadChargeBulkData,
} from "../../api/customerChargesApi";
import Tab from "../../components/Tab";
import ChargeBulkUpload from "../../components/finance/ChargeBulkUpload";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import ActionMenu from "../../components/input/ActionMenu";
import ChargeRevertConfirmation from "./ChargeRevertConfirmation";

const HEADER_FORM = FORMS.CHARGE_CREATION.HEADER.form;

const REVERT_TYPE = {
  INVOICE: 1,
  EV: 2,
};

const fieldPermissions = {
  MULTI_CHARGES: "multiCharges",
  ADDITIONAL_CHARGES: "additionalCharges",
  PICK_REVENUE: "pickRevenue",
  PICK_COST: "pickCost",
  ACTION_MENU: "actionMenu",
  PICK_TEMPLATE: "pickTemplate",
  INVOICE_REVERT: "invoiceRevert",
  EV_REVERT: "evRevert",
};

const ChargeCreation = () => {
  const auth = useSelector((state) => state.user.permissions[MODULES.Finance]);
  const chargeHeaderPermissions = auth[HEADER_FORM];
  const deleteHeaderPermission = chargeHeaderPermissions?.FORM?.DELETE;
  const userCompany = useUserCompany();
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(true);
  const gridRef = useRef();
  const currencyRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [evInvType, setEvInvType] = useState(0);
  const [currentSearchData, setCurrentSearchData] = useState({});
  const [updateNeeded, setUpdateNeeded] = useState(false);
  const [updateTemplates, setUpdateTemplates] = useState(false);
  const [selectedJobCodes, setSelectedJobCodes] = useState([]);

  const getDefaultDateRange = () => {
    const aMonthAgo = new Date();
    aMonthAgo.setMonth(aMonthAgo.getMonth() - 1);
    return {
      from: aMonthAgo.toISOString().split("T")[0],
      to: new Date().toISOString().split("T")[0],
    };
  };

  const [fromDate, setFromDate] = useState(() => getDefaultDateRange().from);
  const [toDate, setToDate] = useState(() => getDefaultDateRange().to);
  const [job, setJob] = useState("");
  const [request, setRequest] = useState("");
  const [transporter, setTransporter] = useState("");
  const [customer, setCustomer] = useState("");
  const [vehicle, setVehicle] = useState("");
  // const [jobStatus, setJobStatus] = useState(22);
  const [jobStatus, setJobStatus] = useState([]);
  const [evNumber, setEvNumber] = useState("");
  const [invNumber, setInvNumber] = useState("");
  const [dateType, setDateType] = useState("");

  const [currentTemplate, setCurrentTemplate] = useState(3);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedRowsSet, setSelectedRowsSet] = useState([]);

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [bulkSearchClicked, setBulkSearchClicked] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState([]);
  const [invoiceParams, setInvoiceParams] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [evEditMode, setEvEditMode] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMultipleDrawerOpen, setIsMultipleDrawerOpen] = useState(false);
  const [isEvinvDrawerOpen, setIsEvinvDrawerOpen] = useState(false);
  const [isBulkMode, setIsBulkMode] = useState(false);

  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [costLoading, setCostLoading] = useState(false);
  const [isMultipleJobs, setIsMultipleJobs] = useState(false);
  const user = useSelector((state) => state.user);
  const [jobCodes, setJobCodes] = useState([]);
  const [jobIdsWithoutCharges, setJobIdsWithoutCharges] = useState([]);
  const [isAdditional, setIsAdditional] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [chgCode, setChgCode] = useState("");
  const [allJobStatus, setAllJobStatus] = useState([]);
  const [revertType, setRevertType] = useState(null);

  useEffect(() => {
    if (jobStatusOptions?.length > 0) {
      let jobStatusValues = [];
      jobStatusOptions.forEach((option) => {
        jobStatusValues.push(option.value);
      });
      setAllJobStatus(jobStatusValues);
    }
  }, [jobStatusOptions]);

  const [currency, setCurrency] = useState(
    userCompany ? userCompany.comCurrency : null,
  );

  console.log("Templates", templates);

  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    setCurrency(userCompany ? userCompany.comCurrency : null);
  }, [userCompany]);

  useEffect(() => {
    (async () => {
      setIsStatusLoading(true);
      const { [STATUS_GROUPS.CHARGES_APPLIED]: chargesAppliedList = [] } =
        await statusIdsByContexts([STATUS_GROUPS.CHARGES_APPLIED]);

      setStatusList(chargesAppliedList);

      setIsStatusLoading(false);
    })();
  }, []);

  console.log("user currency", currency);

  const getJobCodes = (event) => {
    const regex = /^[JOB0-9\-,]*$/;
    const currentValue = event.target.value.toUpperCase();
    if (regex.test(currentValue)) {
      setJob(currentValue);
    } else {
      setJob("");
    }
  };

  const getRequestCodes = (event) => {
    const currentValue = event.target.value.toUpperCase();
    setRequest(currentValue);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setIsEvinvDrawerOpen(false);
    setCurrentTemplate(3);
  };

  const multipleDrawerClose = () => {
    setIsMultipleJobs(false);
    setIsMultipleDrawerOpen(false);
  };

  const openEvinvDrawer = async (type, jobId, editMode) => {
    if (editMode) {
      const invoiceData = await getInvoiceByJobId(jobId, type);
      setIsBulkMode(invoiceData.eihSingleBulk === 2);
      setInvoiceParams(invoiceData);
    } else {
      setIsBulkMode(false);
      setInvoiceParams(null);
    }
    setEvInvType(type);
    setEvEditMode(editMode);
    setIsDrawerOpen(false);
    setIsEvinvDrawerOpen(true);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const templates = await getTemplates();
      console.log("Templates", templates);
      setTemplates(templates);
      setIsLoading(false);
    })();
  }, [updateTemplates]);



  useEffect(() => {
    (async () => {
      if (updateNeeded) {
        await refreshSearch(currentSearchData);
        setUpdateNeeded(false);
      }
    })();
  }, [updateNeeded]);

  const refreshSearch = async (searchData) => {
    setSearchSubmitLoading(true);
    setSearchClicked(true);
    setSelectedRowsSet([]);
    setSelectedJobIds([]);

    // const res = await searchCharge({
    //   fromDate: searchData.fromDate ? searchData.fromDate : null,
    //   toDate: searchData.toDate ? searchData.toDate : null,
    //   transporter: searchData.transporter
    //     ? searchData.transporter.toString()
    //     : "",
    //   vehicle: searchData.vehicle ? searchData.vehicle.toString() : "",
    //   customer: searchData.customer ? searchData.customer.toString() : "",
    //   status: searchData.status ? searchData.status.toString() : "",
    //   jobCode: searchData.jobCode ? searchData.jobCode : "",
    //   requestCode: searchData.requestCode ? searchData.requestCode : "",
    //   evNumber: searchData.evNumber ? searchData.evNumber.toString() : "",
    //   invNumber: searchData.invNumber ? searchData.invNumber.toString() : "",
    // });

    const res = await searchCharge(searchData);
    const mappedRes = res.map((item) => ({
      ...item,
      distance: item.distance !== null ? item.distance : "N/A",
      evStatus: item.evStatus === null ? 1 : item.evStatus,
      chg_code: item.chg_code !== null ? item.chg_code : "N/A",
      invStatus: item.invStatus === null ? 1 : item.invStatus,
    }));
    setSearchRes(mappedRes);
    setSearchSubmitLoading(false);
    setActiveAccordion(false);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!dateType || !fromDate || !toDate) {
      toast.warning("Date Type, From Date and To Date are mandatory", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    setSearchSubmitLoading(true);
    setSelectedRowsSet([]);
    setSelectedJobIds([]);
    setCurrentSearchData({
      dateType: dateType ? dateType : null,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      transporter: transporter ? transporter.toString() : "",
      vehicle: vehicle ? vehicle.toString() : "",
      customer: customer ? customer.toString() : "",
      // status: jobStatus ? jobStatus.toString() : "",
      status:
        jobStatus && jobStatus.length > 0
          ? jobStatus.join(",")
          : allJobStatus.join(","),
      jobCode: job ? job : "",
      requestCode: request ? request : "",
      evNumber: evNumber ? evNumber.toString() : "",
      invNumber: invNumber ? invNumber.toString() : "",
    });

    setSearchClicked(true);

    const res = await searchCharge({
      dateType: dateType ? dateType : null,
      fromDate: fromDate ? fromDate : null,
      toDate: toDate ? toDate : null,
      transporter: transporter ? transporter.toString() : "",
      vehicle: vehicle ? vehicle.toString() : "",
      customer: customer ? customer.toString() : "",
      // status: jobStatus ? jobStatus.toString() : "",
      status:
        jobStatus && jobStatus.length > 0
          ? jobStatus.join(",")
          : allJobStatus.join(","),
      jobCode: job ? job : "",
      requestCode: request ? request : "",
      evNumber: evNumber ? evNumber.toString() : "",
      invNumber: invNumber ? invNumber.toString() : "",
    });

    const mappedRes = res?.map((item) => ({
      ...item,
      distance: item.distance ? item.distance : "N/A",
      evStatus: item.evStatus === null ? 1 : item.evStatus,
      invStatus: item.invStatus === null ? 1 : item.invStatus,
      chg_code: item.chg_code !== null ? item.chg_code : "N/A",
    }));

    setSearchRes(mappedRes);
    setSearchSubmitLoading(false);
    setActiveAccordion(false);
  };

  console.log("searchRes", searchRes);

  useEffect(() => {
    (async () => {
      setStatusLoading(true);
      const jobStatus = await statusByContext(STATUS_GROUPS.JOB_CHARGE);
      setJobStatusOptions(jobStatus);

      const { date_types: dateTypeData } = await getBulkDropdownData([
        { key: "date_types" },
      ]);

      setDateTypeOpt(dateTypeData);
      setStatusLoading(false);
    })();
  }, []);

  const handleReset = (e) => {
    e.preventDefault();
    setSearchFieldReset(true);
    setDateType("");
    const defaultRange = getDefaultDateRange();
    setFromDate(defaultRange.from);
    setToDate(defaultRange.to);
    setJob("");
    setRequest("");
    setTransporter("");
    setCustomer("");
    setVehicle("");
    // setJobStatus(22);
    setJobStatus([]);
    setEvNumber("");
    setInvNumber("");
    setSearchClicked(false);
    setSearchRes([]);
    setSelectedRow({});
    setEditMode(false);
    setIsLoading(false);
    setIsAdditional(false);
  };

  const modalRef = useRef();
  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    modalRef.current.close();
  };

  const pickFromTemplate = (e) => {
    e.preventDefault();
    if (isMultipleJobs) {
      setIsMultipleDrawerOpen(true);
    } else {
      setIsDrawerOpen(true);
    }

    setIsMultipleJobs(false);
    closeModal();
  };

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    console.log("selected data", selectedData);
    setSelectedRowsSet(selectedData);
    if (selectedData.length > 0) {
      setSelectedJobIds(selectedData?.map((item) => item.jobId));
    }
  };

  const pickRevenue = async () => {
    setRevenueLoading(true);

    for (let jobId of selectedJobIds) {
      const jobRow = selectedRowsSet?.find((item) => item.jobId === jobId);
      console.log("jobRow", jobRow);

      if (jobRow?.jobFocRev) {
        toast.error(
          jobRow.jobCode +
            " is marked as FOC for Revenue. Charges cannot be created.",
          { autoClose: 5000, containerId: "Main" },
        );

        continue;
      }

      const revenueCharges = await getChargesFromRatemaster({
        jobId: jobId,
        revcosId: 1,
        currency: currency,
      });
      console.log("revenue charges", revenueCharges);

      if (
        jobRow?.chargeStatus === 1 ||
        jobRow?.chargeStatus === 3 ||
        revenueCharges[0]?.rId === -1
      ) {
        toast.error(
          "Revenue Charges already created for job " + jobRow.jobCode,
          { autoClose: 5000, containerId: "Main" },
        );

        continue;
      }

      const res = await getJobInfo(jobId);
      const jobData = res ? res[0] : {};

      if (revenueCharges?.length > 0) {
        if (jobRow?.chargeStatus === 0) {
          if (jobRow?.chgId === null || !jobRow?.chgId) {
            const response = await chargeCreation({
              jobChargeHeader: {
                chhCompany: company,
                chhRequest: jobData.jobRequest,
                chhJobId: jobData.jobId,
                chhCustomer: jobData.customerId,
                chhSupplier: jobData.transId,
                chhVehicle: jobData.jobVehicle,
                chhKm: jobData.chargeableValue,
                chhRevenue: revenueCharges?.reduce((acc, item) => {
                  return acc + item.rTotal;
                }, 0),
                chhCost: 0,
                chhCurrency: currency,
                chhExchangeRate: null,
                chhDescription1: "",
                chhDescription2: "",
                chhFormDate: jobData.fromDate,
                chhToDate: jobData.toDate,
                chhEvStatus: 1,
                chhInvStatus: 1,
                chhStatus: 2,
                chhActive: 1,
                chhAdditional: false,
              },
              jobChargeDetails: revenueCharges?.map((item) => ({
                chdCompany: company,
                chdChargeType: item.rRevcost,
                chdChacrges: item.rCharge,
                chdValue: item.rValue,
                chdCurrency: currency,
                chdQty: item.rQty ? item.rQty : 1,
                chdDescription: item.rDescription,
                chdUom: item.rUom ? item.rUom : 1,
                chdTotal: item.rTotal,
                chdStatus: 2,
                chdActive: item.rActive,
                chdExcId: -1,
                chdExcRate: 1,
                chdRahId: item.rRahId,
                chdCreatedType: 2,
                chdModifiedType: 2,
              })),
              author: user.username,
            });

            if (response.status === 201) {
              toast.success(response.data + " !", {
                autoClose: 5000,
                containerId: "Main",
              });
              // resetForm();
            } else {
              toast.error(response.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          } else {
            const updateState = {
              created: [],
              modified: [],
              deleted: [],
            };

            updateState.created = revenueCharges?.map((item) => ({
              chdCompany: company,
              chdChargeType: item.rRevcost,
              chdChacrges: item.rCharge,
              chdValue: item.rValue,
              chdCurrency: currency,
              chdQty: item.rQty ? item.rQty : 1,
              chdDescription: item.rDescription,
              chdUom: item.rUom ? item.rUom : 1,
              chdTotal: item.rTotal,
              chdStatus: 2,
              chdActive: item.rActive,
              chdExcId: -1,
              chdExcRate: 1,
              chdRahId: item.rRahId,
              chdCreatedType: 2,
              chdModifiedType: 2,
            }));

            const charges = await getChargesByChhId(jobRow?.chgId);
            const chargeHeader = charges?.jobChargeHeader;

            let currentCharges = [];
            let id = 2;
            for (let currentCharge of charges?.jobChargeDetails) {
              currentCharges.push({
                id: id++,
                chdCompany: currentCharge.chdCompany,
                chdId: currentCharge.chdId,
                chdCharge: currentCharge.chdChargeId,
                chdChacrges: currentCharge.chdChacrges,
                chdDescription: currentCharge.chdDescription,
                chdValue: currentCharge.chdValue,
                chdQty: currentCharge.chdQty,
                chdTotal: currentCharge.chdTotal,
                chdUom: currentCharge.chdUom,
                chdStatus: currentCharge.chdStatus,
                chdActive: currentCharge.chdActive,
                chdChargeType: currentCharge.chdChargeType,
                chdExcId: currentCharge.chdExcId,
                chdExcRate: currentCharge.chdExcRate,
                chdRahId: currentCharge.chdRahId,
                chdCreatedType: currentCharge.chdCreatedType,
                chdModifiedType: currentCharge.chdModifiedType,
              });
            }

            let existingTotalCost = 0;
            let existingTotalRevenue = 0;
            let newTotalCost = 0;
            let newTotalRevenue = 0;

            for (let charge of currentCharges) {
              if (charge.chdId) {
                if (parseInt(charge.chdChargeType) === 1) {
                  if (charge.chdStatus === 2) {
                    existingTotalRevenue += charge.chdTotal;
                  }
                } else {
                  if (charge.chdStatus === 2) {
                    existingTotalCost += charge.chdTotal;
                  }
                }
              }
            }

            newTotalRevenue = revenueCharges?.reduce((acc, item) => {
              return acc + item.rTotal;
            }, 0);

            const totalRevenue = existingTotalRevenue + newTotalRevenue;

            const totalCost = existingTotalCost + newTotalCost;

            try {
              const response = await updateCharges({
                jobChargeHeaderRequest: {
                  ...chargeHeader,
                  chhRevenue: totalRevenue,
                  chhCost: totalCost,
                  chhCurrency: currency,
                },
                jobChargeDetailsRequest: updateState,
                author: user.username,
              });

              if (response.status === 200) {
                toast.success(response.data + " !", {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                toast.error(response.data, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              }
            } catch (e) {
              if (e?.response?.data) {
                toast.error(e?.response?.data, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                toast.error("Error Occurred", {
                  autoClose: 5000,
                  containerId: "Main",
                });
              }
            }
          }
        } else if (jobRow?.chargeStatus === 2) {
          const updateState = {
            created: [],
            modified: [],
            deleted: [],
          };

          updateState.created = revenueCharges?.map((item) => ({
            chdCompany: company,
            chdChargeType: item.rRevcost,
            chdChacrges: item.rCharge,
            chdValue: item.rValue,
            chdCurrency: currency,
            chdQty: item.rQty ? item.rQty : 1,
            chdDescription: item.rDescription,
            chdUom: item.rUom ? item.rUom : 1,
            chdTotal: item.rTotal,
            chdStatus: 2,
            chdActive: item.rActive,
            chdExcId: -1,
            chdExcRate: 1,
            chdRahId: item.rRahId,
            chdCreatedType: 2,
            chdModifiedType: 2,
          }));

          const charges = await getChargesByChhId(jobRow?.chgId);
          const chargeHeader = charges?.jobChargeHeader;

          let currentCharges = [];
          let id = 2;
          for (let currentCharge of charges?.jobChargeDetails) {
            currentCharges.push({
              id: id++,
              chdCompany: currentCharge.chdCompany,
              chdId: currentCharge.chdId,
              chdCharge: currentCharge.chdChargeId,
              chdChacrges: currentCharge.chdChacrges,
              chdDescription: currentCharge.chdDescription,
              chdValue: currentCharge.chdValue,
              chdQty: currentCharge.chdQty,
              chdTotal: currentCharge.chdTotal,
              chdUom: currentCharge.chdUom,
              chdStatus: currentCharge.chdStatus,
              chdActive: currentCharge.chdActive,
              chdChargeType: currentCharge.chdChargeType,
              chdExcId: currentCharge.chdExcId,
              chdExcRate: currentCharge.chdExcRate,
              chdRahId: currentCharge.chdRahId,
              chdCreatedType: currentCharge.chdCreatedType,
              chdModifiedType: currentCharge.chdModifiedType,
            });
          }

          let existingTotalCost = 0;
          let existingTotalRevenue = 0;
          let newTotalCost = 0;
          let newTotalRevenue = 0;

          for (let charge of currentCharges) {
            if (charge.chdId) {
              if (parseInt(charge.chdChargeType) === 1) {
                if (charge.chdStatus === 2) {
                  existingTotalRevenue += charge.chdTotal;
                }
              } else {
                if (charge.chdStatus === 2) {
                  existingTotalCost += charge.chdTotal;
                }
              }
            }
          }

          newTotalRevenue = revenueCharges?.reduce((acc, item) => {
            return acc + item.rTotal;
          }, 0);

          const totalRevenue = existingTotalRevenue + newTotalRevenue;

          const totalCost = existingTotalCost + newTotalCost;

          try {
            const response = await updateCharges({
              jobChargeHeaderRequest: {
                ...chargeHeader,
                chhRevenue: totalRevenue,
                chhCost: totalCost,
                chhCurrency: currency,
              },
              jobChargeDetailsRequest: updateState,
              author: user.username,
            });

            if (response.status === 200) {
              toast.success(response.data + " !", {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error(response.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          } catch (e) {
            if (e?.response?.data) {
              toast.error(e?.response?.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error("Error Occurred", {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          }
        }
      } else {
        toast.error("No revenue charges found for job " + jobData.jobCode, {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    }

    setUpdateNeeded(true);
    setRevenueLoading(false);
  };

  const pickCost = async () => {
    setCostLoading(true);

    for (let jobId of selectedJobIds) {
      const jobRow = selectedRowsSet?.find((item) => item.jobId === jobId);
      console.log("jobRow", jobRow);
      if (jobRow?.jobFocCost) {
        toast.error(
          jobRow.jobCode +
            " is marked as FOC for Cost. Charges cannot be created.",
          { autoClose: 5000, containerId: "Main" },
        );

        continue;
      }
      const costCharges = await getChargesFromRatemaster({
        jobId: jobId,
        revcosId: 2,
        currency: currency,
      });
      console.log("cost charges", costCharges);

      if (
        jobRow?.chargeStatus === 2 ||
        jobRow?.chargeStatus === 3 ||
        costCharges[0]?.rId === -2
      ) {
        toast.error("Cost Charges already created for job " + jobRow.jobCode, {
          autoClose: 5000,
          containerId: "Main",
        });

        continue;
      }

      const res = await getJobInfo(jobId);
      const jobData = res ? res[0] : {};

      if (costCharges?.length > 0) {
        if (jobRow?.chargeStatus === 0) {
          if (jobRow?.chgId === null || !jobRow?.chgId) {
            const response = await chargeCreation({
              jobChargeHeader: {
                chhCompany: company,
                chhRequest: jobData.jobRequest,
                chhJobId: jobData.jobId,
                chhCustomer: jobData.customerId,
                chhSupplier: jobData.transId,
                chhVehicle: jobData.jobVehicle,
                chhKm: jobData.chargeableValue,
                chhRevenue: 0,
                chhCost: costCharges?.reduce((acc, item) => {
                  return acc + item.rTotal;
                }, 0),
                chhCurrency: currency,
                chhExchangeRate: null,
                chhDescription1: "",
                chhDescription2: "",
                chhFormDate: jobData.fromDate,
                chhToDate: jobData.toDate,
                chhEvStatus: 1,
                chhInvStatus: 1,
                chhStatus: 2,
                chhActive: 1,
                chhAdditional: false,
              },
              jobChargeDetails: costCharges?.map((item) => ({
                chdCompany: company,
                chdChargeType: item.rRevcost,
                chdChacrges: item.rCharge,
                chdValue: item.rValue,
                chdCurrency: currency,
                chdQty: item.rQty ? item.rQty : 1,
                chdDescription: item.rDescription,
                chdUom: item.rUom ? item.rUom : 1,
                chdTotal: item.rTotal,
                chdStatus: 2,
                chdActive: item.rActive,
                chdExcId: -1,
                chdExcRate: 1,
                chdRahId: item.rRahId,
                chdCreatedType: 2,
                chdModifiedType: 2,
              })),
              author: user.username,
            });
            console.log("creation response", response);
            if (response.status === 201) {
              toast.success(response.data + " !", {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error(response.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          } else {
            const updateState = {
              created: [],
              modified: [],
              deleted: [],
            };

            updateState.created = costCharges?.map((item) => ({
              chdCompany: company,
              chdChargeType: item.rRevcost,
              chdChacrges: item.rCharge,
              chdValue: item.rValue,
              chdCurrency: currency,
              chdQty: item.rQty ? item.rQty : 1,
              chdDescription: item.rDescription,
              chdUom: item.rUom ? item.rUom : 1,
              chdTotal: item.rTotal,
              chdStatus: 2,
              chdActive: item.rActive,
              chdExcId: -1,
              chdExcRate: 1,
              chdRahId: item.rRahId,
              chdCreatedType: 2,
              chdModifiedType: 2,
            }));

            const charges = await getChargesByChhId(jobRow?.chgId);
            const chargeHeader = charges?.jobChargeHeader;

            let currentCharges = [];
            let id = 2;
            for (let currentCharge of charges?.jobChargeDetails) {
              currentCharges.push({
                id: id++,
                chdCompany: currentCharge.chdCompany,
                chdId: currentCharge.chdId,
                chdCharge: currentCharge.chdChargeId,
                chdChacrges: currentCharge.chdChacrges,
                chdDescription: currentCharge.chdDescription,
                chdValue: currentCharge.chdValue,
                chdQty: currentCharge.chdQty,
                chdTotal: currentCharge.chdTotal,
                chdUom: currentCharge.chdUom,
                chdStatus: currentCharge.chdStatus,
                chdActive: currentCharge.chdActive,
                chdChargeType: currentCharge.chdChargeType,
                chdExcId: currentCharge.chdExcId,
                chdExcRate: currentCharge.chdExcRate,
                chdRahId: currentCharge.chdRahId,
                chdCreatedType: currentCharge.chdCreatedType,
                chdModifiedType: currentCharge.chdModifiedType,
              });
            }

            let existingTotalCost = 0;
            let existingTotalRevenue = 0;
            let newTotalCost = 0;
            let newTotalRevenue = 0;

            for (let charge of currentCharges) {
              if (charge.chdId) {
                if (parseInt(charge.chdChargeType) === 1) {
                  if (charge.chdStatus === 2) {
                    existingTotalRevenue += charge.chdTotal;
                  }
                } else {
                  if (charge.chdStatus === 2) {
                    existingTotalCost += charge.chdTotal;
                  }
                }
              }
            }

            newTotalCost = costCharges?.reduce((acc, item) => {
              return acc + item.rTotal;
            }, 0);

            const totalRevenue = existingTotalRevenue + newTotalRevenue;

            const totalCost = existingTotalCost + newTotalCost;

            try {
              const response = await updateCharges({
                jobChargeHeaderRequest: {
                  ...chargeHeader,
                  chhRevenue: totalRevenue,
                  chhCost: totalCost,
                  chhCurrency: currency,
                },
                jobChargeDetailsRequest: updateState,
                author: user.username,
              });

              if (response.status === 200) {
                toast.success(response.data + " !", {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                toast.error(response.data, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              }
            } catch (e) {
              if (e?.response?.data) {
                toast.error(e?.response?.data, {
                  autoClose: 5000,
                  containerId: "Main",
                });
              } else {
                toast.error("Error Occurred", {
                  autoClose: 5000,
                  containerId: "Main",
                });
              }
            }
          }
        } else if (jobRow?.chargeStatus === 1) {
          const updateState = {
            created: [],
            modified: [],
            deleted: [],
          };

          updateState.created = costCharges?.map((item) => ({
            chdCompany: company,
            chdChargeType: item.rRevcost,
            chdChacrges: item.rCharge,
            chdValue: item.rValue,
            chdCurrency: currency,
            chdQty: item.rQty ? item.rQty : 1,
            chdDescription: item.rDescription,
            chdUom: item.rUom ? item.rUom : 1,
            chdTotal: item.rTotal,
            chdStatus: 2,
            chdActive: item.rActive,
            chdExcId: -1,
            chdExcRate: 1,
            chdRahId: item.rRahId,
            chdCreatedType: 2,
            chdModifiedType: 2,
          }));

          const charges = await getChargesByChhId(jobRow?.chgId);
          const chargeHeader = charges?.jobChargeHeader;

          let currentCharges = [];
          let id = 2;
          for (let currentCharge of charges?.jobChargeDetails) {
            currentCharges.push({
              id: id++,
              chdCompany: currentCharge.chdCompany,
              chdId: currentCharge.chdId,
              chdCharge: currentCharge.chdChargeId,
              chdChacrges: currentCharge.chdChacrges,
              chdDescription: currentCharge.chdDescription,
              chdValue: currentCharge.chdValue,
              chdQty: currentCharge.chdQty,
              chdTotal: currentCharge.chdTotal,
              chdUom: currentCharge.chdUom,
              chdStatus: currentCharge.chdStatus,
              chdActive: currentCharge.chdActive,
              chdChargeType: currentCharge.chdChargeType,
              chdExcId: currentCharge.chdExcId,
              chdExcRate: currentCharge.chdExcRate,
              chdRahId: currentCharge.chdRahId,
              chdCreatedType: currentCharge.chdCreatedType,
              chdModifiedType: currentCharge.chdModifiedType,
            });
          }

          let existingTotalCost = 0;
          let existingTotalRevenue = 0;
          let newTotalCost = 0;
          let newTotalRevenue = 0;

          for (let charge of currentCharges) {
            if (charge.chdId) {
              if (parseInt(charge.chdChargeType) === 1) {
                if (charge.chdStatus === 2) {
                  existingTotalRevenue += charge.chdTotal;
                }
              } else {
                if (charge.chdStatus === 2) {
                  existingTotalCost += charge.chdTotal;
                }
              }
            }
          }

          newTotalCost = costCharges?.reduce((acc, item) => {
            return acc + item.rTotal;
          }, 0);

          const totalRevenue = existingTotalRevenue + newTotalRevenue;

          const totalCost = existingTotalCost + newTotalCost;

          try {
            const response = await updateCharges({
              jobChargeHeaderRequest: {
                ...chargeHeader,
                chhRevenue: totalRevenue,
                chhCost: totalCost,
                chhCurrency: currency,
              },
              jobChargeDetailsRequest: updateState,
              author: user.username,
            });

            if (response.status === 200) {
              toast.success(response.data + " !", {
                autoClose: 5000,
                containerId: "Main",
              });
              // setUpdateNeeded(true);
            } else {
              toast.error(response.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          } catch (e) {
            if (e?.response?.data) {
              toast.error(e?.response?.data, {
                autoClose: 5000,
                containerId: "Main",
              });
            } else {
              toast.error("Error Occurred", {
                autoClose: 5000,
                containerId: "Main",
              });
            }
          }
        }
      } else {
        toast.error("No cost charges found for job " + jobData.jobCode, {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    }

    setUpdateNeeded(true);
    setCostLoading(false);
  };

  const addAdditionalCharges = () => {
    const selectedRow = selectedRowsSet?.[0];
    setSelectedRow(selectedRow);
    setIsMultipleJobs(false);
    setEditMode(false);
    setIsAdditional(true);
    openModal();
  };

  const addChargesForMultipleJobs = () => {
    //filter out the jobs that already have not charges using chargeFlag. If chargeFlag is false, then the job does not have charges
    const filteredJobs = selectedRowsSet?.filter(
      (job) => job.chargeFlag === false,
    );

    //filter jobIds from the filteredJobs
    const jobIds = filteredJobs?.map((job) => job.jobId);

    const jobCodeSet = filteredJobs?.map((job) => job.jobCode);
    setSelectedJobCodes(jobCodeSet);

    setJobCodes(
      jobCodeSet.map((item) => ({
        key: item,
        text: item,
        value: item,
      })),
    );
    if (jobIds.length > 0) {
      setJobIdsWithoutCharges(jobIds);
      setIsMultipleJobs(true);
      setEditMode(false);
      setIsAdditional(false);
      openModal();
    } else {
      toast.error("All selected jobs already have charges", {
        autoClose: 5000,
        containerId: "Main",
      });
    }
  };

  const multiDelete = async () => {
    setIsDeleting(true);

    for (let jobId of selectedJobIds) {
      const jobRow = selectedRowsSet?.find((item) => item.jobId === jobId);
      console.log("jobRow", jobRow);
      if (
        statusList &&
        statusList?.length > 0 &&
        jobRow &&
        jobRow?.statusId &&
        statusList?.includes(jobRow?.statusId)
      ) {
        const res = await deleteCharges({
          chhId: jobRow?.chgId,
          jobId: jobRow?.jobId,
          rtuId: null,
          type: null,
          staId: jobRow?.statusId,
          company: company,
          user: user.username,
        });

        if (res?.status === 200) {
          toast.success(`${res.data} deleted successfully`, {
            autoClose: 5000,
            containerId: "Main",
          });
        } else {
          toast.error(
            `Error in deleting ${jobRow?.chg_code} for ${jobRow?.jobCode}`,
            {
              autoClose: 5000,
              containerId: "Main",
            },
          );
        }
      } else {
        toast.error(
          `Cannot delete ${jobRow?.chg_code} for ${jobRow?.jobCode}`,
          {
            autoClose: 5000,
            containerId: "Main",
          },
        );
      }
    }

    setUpdateNeeded(true);
    setIsDeleting(false);
  };

  const actionMenuHandler = (data) => {
    const hasReturn = selectedRowsSet?.some((r) => r.hasReturnFlag);

    if ((data.value === 2 || data.value === 3) && hasReturn) {
      toast.warning(
        "Return with Booking Remarks Jobs are not applicable here.",
        {
          autoClose: 5000,
          containerId: "Main",
        },
      );
      return;
    }

    switch (data.value) {
      case 1:
        addChargesForMultipleJobs();
        break;

      case 2:
        pickRevenue();
        break;

      case 3:
        pickCost();
        break;

      case 4:
        addAdditionalCharges();
        break;
      case 5:
        multiDelete();
        break;
      case 6:
        setRevertType(REVERT_TYPE.INVOICE);
        break;

      case 7:
        setRevertType(REVERT_TYPE.EV);
        break;

      default:
        break;
    }
  };

  const getActionMenuOptions = () => {
    const actionMenuOptions = [];

    if (selectedRowsSet?.length === 1) {
      const selectedRow = selectedRowsSet[0];
      if (selectedRow?.chgId) {
        if (
          chargeHeaderPermissions[fieldPermissions.ADDITIONAL_CHARGES]?.CREATE
        ) {
          actionMenuOptions.push({
            key: 4,
            text: "Additional Charges",
            value: 4,
          });
        }
      }
    }

    // if (selectedRowsSet?.length >= 2) {
    //   if (chargeHeaderPermissions[fieldPermissions.MULTI_CHARGES]?.CREATE) {
    //     actionMenuOptions.push({
    //       key: 1,
    //       text: "Add Charges",
    //       value: 1,
    //     });
    //   }
    // }

    if (chargeHeaderPermissions[fieldPermissions.PICK_REVENUE]?.VIEW) {
      actionMenuOptions.push({
        key: 2,
        text: "Pick Revenue",
        value: 2,
      });
    }

    if (chargeHeaderPermissions[fieldPermissions.PICK_COST]?.VIEW) {
      actionMenuOptions.push({
        key: 3,
        text: "Pick Cost",
        value: 3,
      });
    }

    if (deleteHeaderPermission) {
      actionMenuOptions.push({
        key: 5,
        text: "Delete",
        value: 5,
      });
    }

    const hasApprovedInvoice = selectedRowsSet?.some(
        (row) =>
            row.chgId != null &&
            Number(row.invStatus) === 3,
    );

    const hasApprovedEv = selectedRowsSet?.some(
        (row) =>
            row.chgId != null &&
            Number(row.evStatus) === 3,
    );

    if (
        chargeHeaderPermissions[fieldPermissions.INVOICE_REVERT]?.VIEW &&
        hasApprovedInvoice
    ) {
      actionMenuOptions.push({
        key: 6,
        text: "Invoice Status Revert",
        value: 6,
      });
    }

    if (
        chargeHeaderPermissions[fieldPermissions.EV_REVERT]?.VIEW &&
        hasApprovedEv
    ) {
      actionMenuOptions.push({
        key: 7,
        text: "EV Status Revert",
        value: 7,
      });
    }

    return actionMenuOptions;
  };

  // drawer tabs
  const [drawerTab, setDrawerTab] = useState(1);
  const [isBulkDrawerOpen, setIsBulkDrawerOpen] = useState(false);
  const [isBulkResponseDrawerOpen, setIsBulkResponseDrawerOpen] =
    useState(false);
  const bulkUploadRef = useRef();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [bulkProceedStatus, setBulkProceedStatus] = useState(null);
  const [chgBulkSearchRes, setChgBulkSearchRes] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [chgBulkDetailSearchRes, setChgBulkDetailSearchRes] = useState(false);

  //search ref
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const versionNumber = useRef(null);

  //search useStates
  const [chargeType, setChargeType] = useState(null);

  // dropdown
  const [bulkProceedStatusOptions, setBulkProceedStatusOptions] = useState([]);
  const [chargeCateOpt, setChargeCateOpt] = useState([]);

  useEffect(() => {
    (async () => {
      if (drawerTab === 1) {
        // const docTypeData = await getDropdownData("doc_type");
        // setDocumentTypeOptions(docTypeData);
        //
        // const extensionData = await getDropdownData(
        //     "file_type",
        //     "2"
        // );
        // console.log("extensionData", extensionData)
        // const extensionType = extensionData.filter(item => [1, 5].includes(item.key));
        // setExtensionOptions(extensionType);

        const chargeCategories = await getDropdownData("chg_category");
        const chargeCategoryData = chargeCategories.filter((item) =>
          [1, 2].includes(item.key),
        );
        setChargeCateOpt(chargeCategoryData);

        const bulkProStat = await getDropdownData("bulk_proceed_status");
        setBulkProceedStatusOptions(bulkProStat);
      }
    })();
  }, [drawerTab]);

  const handleDrawerOpen = () => {
    // dispatch(errorActions.clearDeductMasterError());
    setDrawerTab(1);
    setIsBulkDrawerOpen(true);
  };

  const handleBulkDrawerClose = () => {
    setIsBulkDrawerOpen(false);
    setIsEvinvDrawerOpen(false);
  };

  const handleBulkResponseDrawerClose = () => {
    setIsBulkResponseDrawerOpen(false);
    setEditMode(false);
  };

  const handleBulkUpload = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    setIsLoading(true);
    const document = bulkUploadRef.current.getData();

    if (document.file.length <= 0) {
      toast.error("Please add a file!", { autoClose: 5000, containerId: "Main" });
    } else {
      const uploadedFile = document.file?.[0];
      const data = new FormData();
      data.append("multipartFile", uploadedFile);
      data.append("configId", 1);
      data.append("chargeTypeSeq", document.chargeType);
      data.append("userName", document.userName);
      data.append("company", company);

      try {
        const response = await uploadChargeBulkData(data);
        const result = response.data;

        const skippedDetails = result?.skippedDetails ?? [];
        const skippedCount = result?.skippedCount ?? 0;
        const savedCount = result?.savedCount ?? 0;

        const groupedReasons = skippedDetails.reduce((acc, item) => {
          acc[item.reason] = (acc[item.reason] || 0) + 1;
          return acc;
        }, {});

        const reasonSummary = Object.entries(groupedReasons)
            .map(([reason, count]) => `• ${count} booking(s): ${reason}`)
            .join("\n");

        if (savedCount > 0 && skippedCount === 0) {
          toast.success(`Upload successful! ${savedCount} record(s) uploaded.`,
              { autoClose: 5000, containerId: "Main" });

        } else if (savedCount > 0 && skippedCount > 0) {
          toast.warning(
              <div>
                <strong>Partial upload: {savedCount} saved, {skippedCount} skipped</strong>
                <pre style={{ fontSize: "12px", marginTop: "8px" }}>{reasonSummary}</pre>
              </div>,
              { autoClose: 8000, containerId: "Main" }
          );

        } else if (savedCount === 0 && skippedCount > 0) {
          toast.error(
              <div style={{ minWidth: "300px" }}>
                <strong>Upload failed — all {skippedCount} record(s) skipped:</strong>
                <ul style={{ marginTop: "8px", paddingLeft: "16px" }}>
                  {Object.entries(groupedReasons).map(([reason, count]) => (
                      <li key={reason} style={{ fontSize: "12px", marginBottom: "4px" }}>
                        <b>{count}</b> booking(s): {reason}
                      </li>
                  ))}
                </ul>
              </div>,
              {
                autoClose: 8000,
                containerId: "Main",
                style: { minWidth: "400px" }
              }
          );
        } else {
          toast.warning("No records were uploaded.", { autoClose: 5000, containerId: "Main" });
        }
        bulkUploadRef.current.reset();
      } catch (error) {
        const errorMsg = error.response?.data?.message || "Charge bulk upload failed!";
        toast.error(errorMsg, { autoClose: 5000, containerId: "Main" });
      }
    }
    setIsLoading(false);
    setIsSubmitLoading(false);
  };

  const handleChgBulkSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setBulkSearchClicked(true);
    setSearchSubmitLoading(true);

    const response = await searchBulkJobCharge({
      fromDate: fromDateRef.current.value,
      toDate: toDateRef.current.value,
      versionNumber:
        versionNumber.current.value === "" ? null : versionNumber.current.value,
      chargeType: chargeType,
      proceedStatus: bulkProceedStatus !== 1,
    });
    setChgBulkSearchRes(response);
    setSearchSubmitLoading(false);
  };

  const handleChgBulkSearchReset = () => {
    fromDateRef.current.reset();
    toDateRef.current.reset();
    versionNumber.current.reset();
    setChargeType(null);
    setBulkProceedStatus(null);
  };

  // const handleChargeAdd = async (selectedType) =>{
  //   switch (selectedType.key) {
  //     case 1:
  //       setDrawerTab(1);
  //       setIsBulkDrawerOpen(true);
  //       break;
  //     case 2:
  //       await downloadBulkTemplate(1);
  //       break;
  //   }
  // };
  const handleChargeAdd = async (selectedType) => {
    try {
      switch (selectedType.id) {
        case 1:
          setDrawerTab(1);
          setIsBulkDrawerOpen(true);
          break;
        case 2:
          await downloadBulkTemplate(1);
          break;
        default:
      }
    } catch (error) {
      console.error("Error in handleChargeAdd:", error);
    }
  };

  const bulkChargeOpt = [
    {
      id: 1,
      value: 1,
      text: "Bulk Charge",
    },
    {
      id: 2,
      value: 2,
      text: "Template Download",
    },
  ];
  return (
    <>
      {(revenueLoading || costLoading) && (
          <div className="blur-overlay">
            <LoadingSpinner
                message={
                  costLoading
                      ? "Adding Cost Charges..."
                      : "Adding Revenue Charges..."
                }
            />
          </div>
      )}

      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Search size={15} style={{ marginRight: "5px" }} />
            </span>
            Search
          </div>

          <div
            className={`item ${tab === 2 ? "active" : ""}`}
            onClick={() => {
              setTab(2);
            }}
          >
            <span>
              <Search size={15} style={{ marginRight: "5px" }} />
            </span>
            Charge Bulk Upload
          </div>
        </div>
        {tab === 2 ? (
          <ActionMenu
            title="Action"
            options={bulkChargeOpt}
            onChangeHandler={handleChargeAdd}
            actionMenuStyle={{ width: "8vw", marginRight: "10px" }}
          />
        ) : null}
      </div>

      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion ? "active" : ""}`}
            onClick={() => setActiveAccordion(!activeAccordion)}
          >
            <div>
              Click here to expand search
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion ? "active" : ""}`}>
            {statusLoading && isStatusLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <SearchDropdown
                    key={1}
                    clearable={true}
                    onClear={() => setTransporter("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                  <SearchDropdown
                    key={1}
                    label={"Billing Customer"}
                    clearable={true}
                    onClear={() => setCustomer("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setCustomer(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Billing Customer",
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_stakeholder",
                      primaryKey: "stk_id",
                      fieldName: "stk_name",
                      id: customer,
                    }}
                  />
                  <SearchDropdown
                    key={1}
                    label={"Vehicle"}
                    clearable={true}
                    onClear={() => setVehicle("")}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setVehicle(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "vehicle",
                      value: "",
                    }}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={jobStatusOptions}
                    placeholder="Job Status"
                    label="Job Status"
                    value={jobStatus}
                    onChange={(e, data) => {
                      setJobStatus(data.value);
                    }}
                    multiple={true}
                  />
                  {/* <Dropdown
                        label="Job Status"
                        clearable={false}
                        search={true}
                        options={jobStatusOptions}
                        placeholder="Select Job Status"
                        value={jobStatus}
                        onChange={(e, data) => setJobStatus(data.value)}
                      /> */}
                </div>
                <div className="four fields">
                  <Input
                    type="text"
                    label="Job"
                    placeholder="JOB-1234, JOB-1235, ..."
                    value={job}
                    onChange={getJobCodes}
                  />
                  <Input
                    type="text"
                    label="Request"
                    placeholder="REQ-1234, REQ-1235, ..."
                    value={request}
                    onChange={getRequestCodes}
                  />
                  <Input
                    type="text"
                    label="EV Number"
                    placeholder="EV Number"
                    value={evNumber}
                    onChange={(e) => setEvNumber(e.target.value)}
                  />
                  <Input
                    type="text"
                    label="INV Number"
                    placeholder="INV Number"
                    value={invNumber}
                    onChange={(e) => {
                      setInvNumber(e.target.value);
                    }}
                  />
                </div>
                <div className="three fields">
                  <Dropdown
                    required={true}
                    options={dateTypeOpt}
                    label="Date Type"
                    placeholder="Date Type"
                    style={{ height: "20px" }}
                    value={dateType}
                    onChange={(e, data) => {
                      setDateType(data.value);
                    }}
                    clearable={false}
                  />
                  <Input
                    type="date"
                    required={true}
                    label="From Date"
                    placeholder="From Date"
                    // min={new Date().toISOString().split("T")[0]}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <Input
                    type="date"
                    required={true}
                    label="To Date"
                    placeholder="To Date"
                    min={fromDate}
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearch(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>

        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                ref={gridRef}
                autoHeight={false}
                rowHeight={60}
                multiRowSelection={true}
                onSelectionChanged={handleSelectionChanged}
                content={searchRes}
                showActionMenu={
                  chargeHeaderPermissions[fieldPermissions.ACTION_MENU]?.VIEW &&
                  selectedRowsSet?.length > 0 &&
                  searchRes?.length > 0
                }
                actionMenuOptions={getActionMenuOptions()}
                handleActionMenuChange={actionMenuHandler}
                config={[
                  {
                    headerName: "Job",
                    field: "jobCode",
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                    pinned: "left",
                    minWidth: 160,
                    width: 160,
                  },
                  {
                    headerName: "Request",
                    field: "requestCode",
                    // pinned: "left",
                    minWidth: 160,
                    width: 160,
                  },
                  {
                    headerName: "Charge Code",
                    field: "chg_code",
                    // pinned: "left",
                    minWidth: 160,
                    width: 160,
                  },
                  { headerName: "Vehicle", field: "vehicle" },
                  { headerName: "Containers", field: "connumbers" },
                  {
                    headerName: "Transporter",
                    field: "transporter",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Customer",
                    field: "customer",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Distance",
                    field: "distance",
                    minWidth: 100,
                    width: 100,
                  },
                  {
                    headerName: "Cost Amount",
                    field: "costAmount",
                    minWidth: 150,
                    width: 150,
                  },
                  {
                    headerName: "Cost Approval",
                    field: "costApproval",
                    minWidth: 150,
                    width: 150,
                  },
                  {
                    headerName: "Rev Amount",
                    field: "revAmount",
                    minWidth: 150,
                    width: 150,
                  },
                  {
                    headerName: "Rev Approval",
                    field: "revApproval",
                    minWidth: 150,
                    width: 150,
                  },
                  {
                    headerName: "EV Status",
                    field: "costApproval",
                    cellRenderer: EVInvCellStyle,
                    pinned: "right",
                    minWidth: 120,
                    width: 120,
                  },
                  {
                    headerName: "INV Status",
                    field: "revApproval",
                    cellRenderer: EVInvCellStyle,
                    pinned: "right",
                    minWidth: 120,
                    width: 120,
                  },
                  {
                    headerName: "Status",
                    field: "jobStatus",
                    minWidth: 180,
                    width: 180,
                    cellRenderer: chargeCreationStatusLabelStyle,
                    cellStyle: (params) => ({
                      backgroundColor: params.data.stacolor || "white",
                    }),
                    pinned: "right",
                  },
                  {
                    headerName: "Additional Charge",
                    field: "chgAdditionalValue",
                    minWidth: 150,
                    width: 150,
                    pinned: "right",
                  },
                  {
                    headerName: "Charge Status",
                    field: "chargeFlag",
                    minWidth: 150,
                    width: 150,
                    cellRenderer: ChargeCellStyle,
                    pinned: "right",
                  },
                  {
                    field: "delete",
                    cellRenderer: ButtonRenderer,
                    pinned: "right",
                    width: "120",
                    minWidth: "120",
                    cellRendererParams: (params) => {
                      console.log(params);
                      return {
                        clickHandler: async () => {
                          setIsDeleting(true);
                          setChgCode(params.data.chg_code);
                          try {
                            const res = await deleteCharges({
                              chhId: params.data.chgId,
                              jobId: params.data.jobId,
                              rtuId: null,
                              type: null,
                              staId: params.data.statusId,
                              company: company,
                              user: user.username,
                            });
                            console.log("response", res);
                            if (res?.status === 200) {
                              toast.success(`${res.data} deleted successfully`, {
                                autoClose: 5000,
                                containerId: "Main",
                              });
                              setUpdateNeeded(true);
                            } else {
                              toast.error(res?.data || `Error in deleting`, {
                                autoClose: 5000,
                                containerId: "Main",
                              });
                            }
                          } catch (error) {
                            const errorMessage = error.response?.data || "Cannot delete: This charge was modified in another session.";
                            toast.error(errorMessage, {
                              autoClose: 7000,
                              containerId: "Main",
                            });
                          } finally {
                            setIsDeleting(false);
                          }
                        },
                        // label: "Delete",
                        Icon: MdDeleteForever,
                        className: "ui red button",
                        disabled:
                          deleteHeaderPermission &&
                          params.data.evStatus === 1 &&
                          params.data.invStatus === 1 &&
                          params.data.chgId &&
                          params.data.chgId !== null
                            ? false
                            : true,
                      };
                    },
                  },
                ]}
                onCellDoubleClicked={(props) => {
                  if (chargeHeaderPermissions.FORM?.CREATE) {
                    if (props.data.chargeFlag) {
                      setSelectedJobId(props.data.jobId);
                      setSelectedRow(props.data);
                      setEditMode(true);
                      setCurrentTemplate(null);
                      setIsDrawerOpen(true);
                    } else {
                      setEditMode(false);
                      setSelectedRow(props.data);
                      if (
                        chargeHeaderPermissions[fieldPermissions.PICK_TEMPLATE]
                          ?.VIEW
                      ) {
                        openModal();
                      } else {
                        if (isMultipleJobs) {
                          setIsMultipleDrawerOpen(true);
                        } else {
                          setIsDrawerOpen(true);
                        }
                        setIsMultipleJobs(false);
                        setIsAdditional(false);
                      }
                    }
                  }
                }}
              />
            )}
          </>
        )}
      </div>

      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>

          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  {/* <Dropdown
                        // required={true}
                        options={dateTypeOpt}
                        label="Date Type"
                        placeholder="Date Type"
                        style={{ height: "20px" }}
                        value={bulkDateType}
                        onChange={(e, data) => {
                          setBulkDateType(data.value);
                        }}
                        clearable={false}
                      /> */}
                  <Input
                    label="From Date"
                    type="date"
                    name="from_date"
                    placeholder="From Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="to_date"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                  <Input
                    type="number"
                    step="0.0001"
                    label="Version Number"
                    placeholder="Version Number"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                    ref={versionNumber}
                  />
                  <Dropdown
                    label="Charge Types"
                    placeholder="Charge Type"
                    options={chargeCateOpt}
                    value={chargeType}
                    onChange={(e, data) => {
                      setChargeType(data.value);
                    }}
                    style={{ height: "5px" }}
                    clearable={false}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Proceed Status"
                    placeholder="Proceed Status"
                    options={bulkProceedStatusOptions}
                    value={bulkProceedStatus}
                    style={{ height: "5px" }}
                    onChange={(e, data) => {
                      setBulkProceedStatus(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleChgBulkSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleChgBulkSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {bulkSearchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={chgBulkSearchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "jcehId",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Version Number",
                    field: "jcehVersionNumber",
                  },
                  {
                    headerName: "File Name",
                    field: "jcehFileName",
                  },
                  {
                    headerName: "Charge Type Name",
                    field: "chargeTypeLabel",
                  },
                  {
                    headerName: "Proceed Status",
                    field: "proceedStatusLabel",
                    cellRenderer: BulkProceedStatusStyle,
                  },
                  {
                    headerName: "Created Date",
                    field: "createdDate",
                    cellRenderer: DateCellRenderer,
                    minWidth: 250,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await JobChargeDetailsById(
                    props.data.jcehId,
                  );
                  console.log("-------");
                  console.log(response);
                  setChgBulkDetailSearchRes(response);
                  setDrawerTab(2);
                  setIsBulkResponseDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isBulkDrawerOpen}
        handleDrawerClose={handleBulkDrawerClose}
        body={
          <form className="drawer-content" onSubmit={handleBulkUpload}>
            <div className={"deduction-card-container"}>
              <div style={{ width: "60vw", boxShadow: "none" }}>
                <div className="ui top attached tabular menu">
                  <Tab
                    Icon={Upload}
                    onClick={() => {
                      setDrawerTab(1);
                    }}
                    active={drawerTab === 1}
                    label="Bulk Upload"
                  />
                </div>
                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 1 ? "block" : "none" }}
                >
                  <ChargeBulkUpload ref={bulkUploadRef} isLoading={isLoading} />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {drawerTab === 1 && !isLoading ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
      <SideDrawer
        open={isBulkResponseDrawerOpen}
        handleDrawerClose={handleBulkResponseDrawerClose}
        body={
          <div className={"deduction-card-container"}>
            <div style={{ width: "60vw", boxShadow: "none" }}>
              <div className="ui top attached tabular menu">
                <Tab
                  Icon={List}
                  onClick={() => {
                    setDrawerTab(2);
                  }}
                  active={drawerTab === 2}
                  label="Bulk Job Charge"
                />
              </div>

              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 2 ? "block" : "none" }}
              >
                {searchSubmitLoading ? (
                  <LoadingSpinner />
                ) : (
                  <Grid
                    isLoading={searchFetchLoading}
                    content={chgBulkDetailSearchRes}
                    config={[
                      {
                        headerName: "Id",
                        field: "jceldId",
                        sort: "desc",
                        hide: true,
                      },
                      {
                        headerName: "Booking Number",
                        field: "jceldBookingNumber",
                      },
                      {
                        headerName: "Transport Charges",
                        field: "jceldTransportCharges",
                      },
                      {
                        headerName: "Unloading Charges",
                        field: "jceldUnloadingCharges",
                      },
                      {
                        headerName: "Management Fee",
                        field: "jceldManagementFee12",
                      },
                      {
                        headerName: "Highway Charges",
                        field: "jceldHighwayCharges",
                      },
                      {
                        headerName: "Tona Charges",
                        field: "jceldTonaCharges",
                      },
                      {
                        headerName: "Container Charges",
                        field: "jceldContainerCharges",
                      },
                      {
                        headerName: "Dropping Point Charges",
                        field: "jceldDroppingPointCharges",
                      },
                      {
                        headerName: "Management Fee",
                        field: "jceldManagementFee10",
                      },
                      {
                        headerName: "Lashing Charges",
                        field: "jceldLashingCharges",
                      },
                      {
                        headerName: "Yard Ot Charges",
                        field: "jceldYardOtCharges",
                      },
                      {
                        headerName: "Management Fee",
                        field: "jceldManagementFee",
                      },
                      {
                        headerName: "Additional KM",
                        field: "jceldAdditionalKm",
                      },
                      {
                        headerName: "Fuel Adjustment Fee",
                        field: "jceldFuelAdjustmentFee",
                      },
                      {
                        headerName: "Recoveries",
                        field: "jceldRecoveries",
                      },
                      {
                        headerName: "Transit Violation",
                        field: "jceldTransitViolation",
                      },
                      {
                        headerName: "Boi Parking",
                        field: "jceldBoiParking",
                      },
                      {
                        headerName: "Container Return Charge",
                        field: "jceldContainerReturnCharge",
                      },
                      {
                        headerName: "Yard Ot",
                        field: "jceldYardOt",
                      },
                      {
                        headerName: "Porter Charge",
                        field: "jceldPorterCharge",
                      },
                      {
                        headerName: "Fuel Recover Charge",
                        field: "jceldFuelRecoveries",
                      },
                      {
                        headerName: "Additional Transport Charge",
                        field: "jceldAdditionalTransportCharge",
                      },
                      {
                        headerName: "Late Deduction",
                        field: "jceldLateDeduction",
                      },
                      {
                        headerName: "Spot  Hire Deduction",
                        field: "jceldSpotHireDeduction",
                      },
                      {
                        headerName: "Advance Discount",
                        field: "jceldAdvanceDiscount",
                      },
                      {
                        headerName: "Transport Charge",
                        field: "jceldTransportCharge",
                      },
                      {
                        headerName: "Discount",
                        field: "jceldDiscount",
                      },
                      {
                        headerName: "Supplier Cash Advance",
                        field: "jceldSupplierCashAdvance",
                      },
                      {
                        headerName: "Accommodation Charge",
                        field: "jceldAccommodationCharge",
                      },
                      {
                        headerName: "Custom And Boi Verifications",
                        field: "jceldCustomAndBoiVerifications",
                      },
                      {
                        headerName: "Handling Charges",
                        field: "jceldHandlingCharges",
                      },
                      {
                        headerName: "Monitoring Fee",
                        field: "jceldMonitoringFee",
                      },
                      {
                        headerName: "Labour Charges",
                        field: "jceldLabourCharges",
                      },
                      {
                        headerName: "Lift On Lift Off Charges",
                        field: "jceldLiftOnLiftOffChgs",
                      },
                      {
                        headerName: "Load On Load Off Charges",
                        field: "jceldLoadOnLoadOffChgs",
                      },
                      {
                        headerName: "Load Unload",
                        field: "jceldLoadUnload",
                      },
                      {
                        headerName: "Loading Charges",
                        field: "jceldLoadingCharges",
                      },
                      {
                        headerName: "Data Recovries",
                        field: "jceldDataRecovries",
                      },
                      {
                        headerName: "Management Fee15",
                        field: "jceldManagementFee15",
                      },
                      {
                        headerName: "jceldManagementFee5",
                        field: "jceldManagementFee5",
                      },
                      {
                        headerName: "Mounting De Mounting",
                        field: "jceldMountingDeMounting",
                      },
                      {
                        headerName: "Night Park Charge",
                        field: "jceldNightParkCharge",
                      },
                      {
                        headerName: "jceldOtCharges",
                        field: "jceldOtCharges",
                      },
                      {
                        headerName: "Deduction",
                        field: "jceldDeduction",
                      },
                      {
                        headerName: "Washing Charges",
                        field: "jceldWashingCharges",
                      },
                      {
                        headerName: "Weighing Charges",
                        field: "jceldWeighingCharges",
                      },
                      {
                        headerName: "CargoDamage",
                        field: "jceldCargoDamage",
                      },
                      {
                        headerName: "Storage Charges",
                        field: "jceldStorageCharges",
                      },
                      {
                        headerName: "Return Charges",
                        field: "jceldReturnCharges",
                      },
                      {
                        headerName: "SpotHire Cost",
                        field: "jceldSpotHireCost",
                      },
                      {
                        headerName: "Tally Fee",
                        field: "jceldTallyFee",
                      },
                      {
                        headerName: "Transloading Cost",
                        field: "jceldTransloadingCost",
                      },
                      {
                        headerName: "Additional Charges",
                        field: "jceldAdditionalCharges",
                      },
                      {
                        headerName: "Boi Charge",
                        field: "jceldBoiCharge",
                      },
                      {
                        headerName: "Boi Pass",
                        field: "jceldBoiPass",
                      },
                      {
                        headerName: "Container Charge",
                        field: "jceldContainerChgs",
                      },
                      {
                        headerName: "Demmurrage Charge",
                        field: "jceldDemmurrageChgs",
                      },
                      {
                        headerName: "Demounting",
                        field: "jceldDemounting",
                      },
                      {
                        headerName: "Detention Charges",
                        field: "jceldDetentionCharges",
                      },
                      {
                        headerName: "Detention Qty",
                        field: "jceldDetentionQty",
                      },
                      {
                        headerName: "Charge Name",
                        field: "jceldChargeName",
                      },
                      {
                        headerName: "Charge Value",
                        field: "jceldChargeValue",
                      },
                      {
                        headerName: "Solo Job",
                        field: "jceldSoloJob",
                      },
                      {
                        headerName: "Created By",
                        field: "createdBy",
                      },
                      {
                        headerName: "Created Date",
                        field: "createdDate",
                        cellRenderer: DateCellRenderer,
                      },
                      {
                        headerName: "Last Modified By",
                        field: "lastModifiedBy",
                      },
                      {
                        headerName: "Last Modified Date",
                        field: "lastModifiedDate",
                        cellRenderer: DateCellRenderer,
                      },
                      {
                        headerName: "Status Description",
                        field: "jceldStatusDescription",
                        minWidth: 250,
                      },
                      {
                        headerName: "Charge Creation Status",
                        field: "chargeCreationStatus",
                      },
                      {
                        headerName: "Proceed Status",
                        field: "jceldProceedStatus",
                        cellRenderer: BulkProceedStatusStyle,
                        pinned: "right",
                      },
                    ]}
                  />
                )}
              </div>
            </div>
          </div>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            {!editMode && (
              <div style={{ padding: "10px 0 10px 0" }}>
                <h3>Add Charges To : {selectedRow?.jobCode}</h3>
              </div>
            )}

            {editMode && (
              <div style={{ padding: "10px 0 10px 0" }}>
                <h3>Edit Charges of : {selectedRow?.jobCode}</h3>
              </div>
            )}
          </div>
        }
        body={
          <AddCharges
            isAdditional={isAdditional}
            jobInfo={selectedRow}
            template={currentTemplate}
            editMode={editMode}
            handleDrawerClose={handleDrawerClose}
            handleOpenEvinvDrawer={openEvinvDrawer}
            setUpdateNeeded={setUpdateNeeded}
            setUpdateTemplates={setUpdateTemplates}
            updateTemplates={updateTemplates}
          />
        }
        style={{ width: "90vw", boxShadow: "none" }}
      />

      <SideDrawer
        open={isMultipleDrawerOpen}
        handleDrawerClose={multipleDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>
                Add Charges To :{selectedJobCodes?.map((item) => item + ",")}
              </h3>
            </div>
          </div>
        }
        body={
          <AddMultipleCharges
            isAdditional={isAdditional}
            jobIds={jobIdsWithoutCharges}
            jobCodes={jobCodes}
            template={currentTemplate}
            handleDrawerClose={multipleDrawerClose}
            setUpdateNeeded={setUpdateNeeded}
            setUpdateTemplates={setUpdateTemplates}
            updateTemplates={updateTemplates}
          />
        }
        style={{ width: "90vw", boxShadow: "none" }}
      />

      <SideDrawer
        open={isEvinvDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>EV/Inv Generator</h3>
            </div>
          </div>
        }
        body={
          <EvinvComponent
            categoryId={evInvType}
            jobId={selectedJobId}
            editMode={evEditMode}
            invoiceParams={invoiceParams}
            jobIds={[]}
            bulkMode={isBulkMode}
          />
        }
        style={{ width: "90vw", boxShadow: "none" }}
      />

      <Modal ref={modalRef} minHeight="60vh" minWidth="50vw">
        <input
          type="text"
          style={{ position: "absolute", opacity: 0 }}
          autoFocus
        />
        {!editMode && searchRes?.length > 0 && (
          <div className="two fields">
            <div className="field">
              <Dropdown
                clearable={true}
                label="Select Template"
                search
                options={templates}
                placeholder={isLoading ? "Loading..." : "Select Template"}
                style={{ height: "20px" }}
                value={currentTemplate}
                onChange={(e, data) => {
                  setCurrentTemplate(data.value);
                }}
                disabled={isLoading ? true : false}
              />
            </div>
            <div style={{ height: "20px", margin: "25px 0 0 0" }}>
              <Button
                label="Pick From Template"
                disabled={currentTemplate ? false : true}
                onClick={(e) => {
                  pickFromTemplate(e);
                }}
              />
            </div>
          </div>
        )}
      </Modal>

      <ChargeRevertConfirmation
          open={revertType !== null}
          type={revertType}
          selectedRows={selectedRowsSet}
          onClose={() => setRevertType(null)}
          onCompleted={() => {
            setSelectedRowsSet([]);
            setSelectedJobIds([]);
            setUpdateNeeded(true);
          }}
      />

      {isDeleting && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Deleting ${chgCode}...`} />
        </div>
      )}
    </>
  );
};

export default ChargeCreation;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
